var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._l(_vm.children, function (child, index) {
    return _c('div', {
      key: child.question_id,
      staticClass: "mb-10"
    }, [_c('span', [_vm._v(_vm._s(child.title))]), _c('my-input', {
      staticClass: "rule-title-input mt-10",
      attrs: {
        "max-length": 100,
        "placeholder": _vm.t('')
      },
      on: {
        "change": _vm.handleChange
      },
      model: {
        value: _vm.value[index].option_id,
        callback: function ($$v) {
          _vm.$set(_vm.value[index], "option_id", $$v);
        },
        expression: "value[index].option_id"
      }
    })], 1);
  }), 0);
};

var staticRenderFns = [];
export { render, staticRenderFns };